import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Location } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, signal, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, Router } from '@angular/router';
import { DocumentoService } from '../../../services/documento.service';
import { Documento, NumeracionDocumento, TramitePortal } from '../../../models/Document';
import { MatTab, MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { ParticipantesType } from '../../../models/ParticipantesType';
import { Participante } from '../../../models/ParticipanteType';
import { AuthService } from '../../../services/auth.service';
import { CapitalizePipe } from "../../../pipes/capitalize.pipe";
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { participantesValidator } from '../../nuevo/nuevo.component';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { DocumentTypeService } from '../../../services/document-type.service';
import { DocumentType } from '../../../models/DocumentType';
import { MatInputModule } from '@angular/material/input';
import { FilesService } from '../../../shared/files.service';
import { AnexoService } from '../../../services/anexo.service';
import { Anexo } from '../../../models/Anexo';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { DlgNumeracionComponent } from '../../nuevo/dlg-numeracion/dlg-numeracion.component';
import { NgxSuneditorComponent, NgxSuneditorModule } from '../../../../../projects/ngx-suneditor/src/public-api';
import { SunEditorOptions } from 'suneditor/src/options';
import plugins from 'suneditor/src/plugins';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { DateService } from '../../../shared/date.service';
import { TareaService } from '../../../services/tarea.service';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../../commons/toast.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DlgAnexosTareaComponent } from '../../../commons/dlg-anexos-tarea/dlg-anexos-tarea.component';
import { DlgDeleteComponent } from '../../../commons/dlg-delete/dlg-delete.component';
import { DlgSignatureComponent } from '../../../commons/dlg-signature/dlg-signature.component';
import { DlgDestinoComponent } from '../../nuevo/dlg-destino/dlg-destino.component';
import { AnexosFullComponent } from "../../../commons/anexos-full/anexos-full.component";
import { DlgConfirmComponent, DlgConfirmComponentData } from '../../../commons/dlg-confirm/dlg-confirm.component';
import { UtilService } from '../../../services/util.service';
import { AppTitleService } from '../../../services/app-title.service';
import { EditorType } from '../../../emuns/EditorType';
import { WopiService } from '../../../services/wopi.service';
import { Wopi } from '../../../models/Wopi';
import { WopiAccion } from '../../../emuns/WopiAccion';
import { CollaboraEditorComponent } from '../../../commons/collabora-editor/collabora-editor.component';

@Component({
  selector: 'app-responder',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatTabsModule,
    MatCardModule,
    CapitalizePipe,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatOptionModule,
    MatInputModule,
    MatTooltipModule,
    NgxSuneditorModule,
    MatProgressSpinnerModule,
    MatListModule,
    AnexosFullComponent,
    CollaboraEditorComponent
  ],
  templateUrl: './responder.component.html',
  styleUrl: './responder.component.scss'
})
export class ResponderComponent implements OnInit {
  @ViewChild(NgxSuneditorComponent) ngxSunEditor!: NgxSuneditorComponent;
  @ViewChild('collaboraEditorComponent') collaboraEditor?: CollaboraEditorComponent;
  @ViewChild(AnexosFullComponent) anexosFullComponent!: AnexosFullComponent;
  public editorHasFocus: boolean = false;
  public fullscreenActive: boolean = false;
  editorOptions: SunEditorOptions = {
    minWidth: "100%",
    height: "50vh",
    plugins: plugins,
    buttonList: [
      ["undo", "redo"],
      ["font", "fontSize", "formatBlock"],
      ["bold", "underline", "italic"],
      ["fontColor", "hiliteColor", "removeFormat"],
      ["outdent", "indent"],
      ["align", "list"],
      ["table"],
      ["codeView"]
    ],
    defaultStyle: "font-family: arial; font-size: 12px; text-align: justify;",
    font: ["Arial"],
    fontSize: [8, 10, 12],
    alignItems: ['justify']
  };

  documentID = this.route.snapshot.params["documentID"];
  document!: Documento
  anexos: Anexo[] = []

  documentTypes: DocumentType[] = []
  tipoDocumentoSeleccionado: DocumentType | null = null
  defaultDocumentType = ""
  numeracionesDocumento: NumeracionDocumento[] = [];
  numeracionDocumento?: NumeracionDocumento;
  @ViewChild('numeracionInput') numeracionInput: ElementRef<HTMLInputElement> | undefined;


  readOnlyNumeracion = true;

  participantes: ParticipantesType = {
    origen: [],
    destino: [],
    copia: [],
    destinoBuzon: []
  };

  replyForm = new FormGroup({
    documentType: new FormControl("", {
      validators: [Validators.required, Validators.pattern(/^[0-9]+$/)]
    }),
    category: new FormControl("", {
      validators: [Validators.required]
    }),
    tipificacion: new FormControl("", {
      validators: [Validators.required]
    }),
    numeroReferencia: new FormControl("", {
      validators: [Validators.required]
    }),
    numeracion: new FormControl("", {
      validators: [Validators.required]
    }),
    asunto: new FormControl("", {
      validators: [Validators.required, Validators.maxLength(250)]
    }),
    participantes: new FormControl<ParticipantesType>(this.participantes, {
      validators: [
        participantesValidator(),
      ]
    }),
    cuerpo: new FormControl("", { validators: [] }),
    anexos: new FormControl<Anexo[]>(this.anexos)
  })

  snackbarData: ScnackbarData = {}

  fetchingReplyDocument = false
  isPreview = false

  tokenData: any = this.authService.getTokenData();

  hasParticipated = false
  isOwner = false  

  estadoTarea: number = -1
  idTarea: number = -1
  alcanceMode: boolean = false;

  EditorType = EditorType
  editor = signal<EditorType>(EditorType.odt)

  collaboraUrl: string = '';
  collaboraDocumentId: string = '';

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private documentService: DocumentoService,
    private utilService: UtilService,
    private authService: AuthService,
    private documentTypeService: DocumentTypeService,
    private filesService: FilesService,
    private anexosService: AnexoService,
    public dlg: MatDialog,
    private cdr: ChangeDetectorRef,
    private dateService: DateService,
    private tareaService: TareaService,
    private toast: ToastService,
    private router: Router,
    private utilServ: UtilService,
    private appTitleService: AppTitleService,
    private wopiService: WopiService
  ) {
    this.appTitleService.setTitle("Responder Documento");
  }

  ngOnInit(): void {
    this.documentID = this.route.snapshot.paramMap.get("documentID");
    const urls = this.route.snapshot.url;

    this.documentService.getById(this.documentID).subscribe({
      next: (response) => {
        if (urls.length > 0 && urls[0].path === "alcance") {
          this.appTitleService.setTitle("Alcance Documento: " + response.anio + "-" + response.numero);
          this.alcanceMode = true
        } else {
          this.appTitleService.setTitle("Responder Documento: " + response.anio + "-" + response.numero);
        }

        this.document = response
        this.editor.set(this.alcanceMode ? EditorType.odt : this.document.editor)

        this.loadAnexosRamal(this.document.idTarea)
        this.loadDocumentTypes()
        this.replyForm.controls.category.setValue(this.document.categoria.toString())
        this.replyForm.controls.tipificacion.setValue(this.document.tipificacion.toString())
        this.replyForm.controls.numeroReferencia.setValue(this.document.numeroDocumento)

        if (this.alcanceMode) {
          //por defecto el alcance es con nuevo editor odt
          this.participantes.origen = this.document.de as Participante[];

          this.replyForm.controls.asunto.setValue("Alcance \"" + this.document.asunto + "\"")

          /*if (this.document!.editor == EditorType.odt) {*/

            this.wopiService.preparar(WopiAccion.nuevo).subscribe((wopi: Wopi) => {

              this.collaboraDocumentId = wopi.id;
              this.collaboraUrl = wopi.url;
              this.cdr.detectChanges();
            })

         /* } else {
            this.cdr.detectChanges();
            this.setCuerpoDocumentoAlcance()
          }*/
        } else {

          if (this.document!.editor == EditorType.odt) {

            this.wopiService.preparar(WopiAccion.responder, this.document!.idTarea).subscribe((wopi: Wopi) => {
              this.collaboraDocumentId = wopi.id;
              this.collaboraUrl = wopi.url;
              this.cdr.detectChanges();
            })

          } else {
            this.cdr.detectChanges();
            this.setCuerpoDocumento()
          }

          this.participantes.origen = this.document.para as Participante[];
          this.participantes.destino = this.document.de as Participante[]
          //this.participantes.destinoBuzon = this.document.buzonesPara;
          this.replyForm.controls.asunto.setValue(this.document.asunto)
        }

        this.replyForm.controls.participantes.setValue(this.participantes)

        this.utilServ.getParticipacionUsuarioDocumento(this.document.id).subscribe({
          next: (_) => {            
            this.hasParticipated = true
          },
          error: (_) => {            
            this.hasParticipated = false
          }
        })

        this.estadoTarea = this.document.estadoTarea;        

        if (this.document.tipoAsignado === 1 && this.document.participanteReasigna) {
          this.isOwner = this.document.participanteReasigna == this.tokenData.id
        } else {
          this.isOwner = this.document.codigoParticipante == this.tokenData.id
        }
      }
    })
  }

  loadAnexosRamal(idTarea: number) {
    this.anexosService.getAnexosRamal(idTarea).subscribe({
      next: (response) => {
        this.anexos = response
        this.replyForm.controls.anexos.setValue(this.anexos)
      },
      error: () => {
        // Fallback para no bloquear la pantalla si falla la carga por ramal.
        this.anexos = this.document?.anexos ? [...this.document.anexos].reverse() : []
        this.replyForm.controls.anexos.setValue(this.anexos)
      }
    })
  }

  async submitReplyDocumentForm() {
    this.fetchingReplyDocument = true

    if (this.editor() === EditorType.odt && this.collaboraEditor) {
      await this.collaboraEditor?.saveAndWait();
    }

    const controls = this.replyForm.controls
    this.idTarea = this.document.idTarea;
    let tramitePortal: TramitePortal = {
      id: this.document.idTarea,
      tipoDocumento: controls.documentType.value!,
      tipoSolicitante: 1,
      categoria: parseInt(controls.category.value!),
      tipificacion: parseInt(controls.tipificacion.value!),
      fecha: this.dateService.formatDateToCustomString(new Date()),
      numeroDocumento: controls.numeracion.value!,
      numeroReferencia: controls.numeroReferencia.value!,
      asunto: controls.asunto.value!,
      cuerpo: controls.cuerpo.value!,
      anexos: controls.anexos.value!,
      anexosMencionados: this.getAnexosMencionados(),
      de: controls.participantes.value!.origen,
      para: controls.participantes.value!.destino,
      cc: controls.participantes.value!.copia,
      buzonesPara: controls.participantes.value!.destinoBuzon,
      editor: this.editor(),
      collaboraId: this.collaboraDocumentId
    }

    this.documentService.respuestaAlcanceTarea(tramitePortal, this.alcanceMode).subscribe(({
      next: (response) => {
        this.snackbarData.message = (this.alcanceMode) ? "Alcance al documento realizado!" : "Documento respondido!"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.fetchingReplyDocument = false
        this.toast.show(this.snackbarData)
        this.utilService.callTasks();
        if (this.isPreview) {
          this.idTarea = response.id!;
          this.documentID = response.id!.toString()
          this.loadAnexos()
        } else {
          this.router.navigateByUrl("/finalizar/" + response.id);
        }
      },
      error: () => {
        this.snackbarData.message = (this.alcanceMode) ? "Error realizando alcance al documento!" : "Error respondiendo documento!"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.fetchingReplyDocument = false
        this.toast.show(this.snackbarData)
      }
    }))
  }

  manageChangedDocumentType(event: MatSelectChange) {
    const selectedDocumentType = this.documentTypes.find((type) => type.id == event.value)
    this.tipoDocumentoSeleccionado = selectedDocumentType!
    if (this.numeracionDocumento) {
      this.setNumeracion(this.numeracionDocumento?.numeracion)
    } else {
      if (this.replyForm.controls.numeracion.value) {
        var valor = this.replyForm.controls.numeracion.value;
        var num = this.replyForm.controls.numeracion.value.substring(0, valor.length - 3)
        num = num + "-" + this.tipoDocumentoSeleccionado!.descripcion.substring(0, 2).toUpperCase()
        this.replyForm.controls.numeracion.setValue(num);
      }
    }
  }

  loadAnexos() {
    this.anexosService.listAnexosByDocumentID(parseInt(this.documentID!)).subscribe({
      next: (response) => {
        this.anexos = response
        this.replyForm.controls.anexos.setValue(this.anexos)
        if (this.isPreview) {
          this.isPreview = false
          this.openDlgSign()
        }
      },
      error: () => {
        // En alcance la respuesta puede devolver id de tarea; usamos ramal como fallback.
        this.anexosService.getAnexosRamal(this.idTarea).subscribe({
          next: (anexosRamal) => {
            this.anexos = anexosRamal
            this.replyForm.controls.anexos.setValue(this.anexos)
            if (this.isPreview) {
              this.isPreview = false
              this.openDlgSign()
            }
          },
          error: () => {
            this.toast.show({
              style: SnackbarStyles.Warning,
              message: "Se generó el documento, pero no se pudo abrir la vista previa"
            });
          }
        })
      }
    })
  }

  openDlgSign() {
    const anexoOficio = this.anexos.find((anexo) => anexo.tipo === 0 && anexo.tarea === this.idTarea)
      ?? this.anexos.find((anexo) => anexo.tipo === 0);

    if (!anexoOficio?.id) {
      this.toast.show({
        style: SnackbarStyles.Warning,
        message: "No se encontró el anexo principal para la vista previa"
      });
      return;
    }

    const dlgSign = this.dlg.open(DlgSignatureComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      panelClass: 'full-screen-modal',
      data: {
        firmar: 0,
        idAnx: anexoOficio.id
      },
    });

    dlgSign.afterClosed().subscribe(result => {
      if (this.idTarea > 0) {
        this.router.navigateByUrl("/editar/" + this.idTarea);
      }
      if (this.documentID) {
        this.appTitleService.setTitle("Responder Documento");
      }
      if (this.alcanceMode) {
        this.appTitleService.setTitle("Alcance Documento");
      }

    })
  }

  openDlgDestino() {
    const dlgDestino = this.dlg.open(DlgDestinoComponent, {
      width: '80vw',
      maxWidth: '80vw',
      data: this.participantes
    });

    dlgDestino.afterClosed().subscribe(result => {
      if (result) {
        this.participantes = result;
        this.replyForm.controls.participantes.setValue(this.participantes)
      }
    });
  }

  setCuerpoDocumento() {
    const cuerpo = `<p>De mi consideración: </p>

<p>En respuesta al documento No. ${this.document.numeroDocumento}</p><br>

${this.document.cuerpo}<br>

<p>Con sentimientos de distinguida consideración.</p>`

    this.replyForm.controls.cuerpo.setValue(cuerpo)
    this.ngxSunEditor.setContents(cuerpo)
  }

  setCuerpoDocumentoAlcance() {

    const cuerpo = `<p>De mi consideración: </p>

<p>En alcance No. ${this.document.numeroDocumento}</p><br>

<p>Con sentimientos de distinguida consideración.</p>`

    this.replyForm.controls.cuerpo.setValue(cuerpo)
    this.ngxSunEditor.setContents(cuerpo)
  }

  manageEditorContentChange(event: { content: string; core: unknown }) {
    this.replyForm.controls.cuerpo.setValue(event.content)
    this.cdr.detectChanges()
  }

  loadDocumentTypes() {
    this.documentTypeService.list().subscribe({
      next: (response) => {
        this.documentTypes = response
        this.replyForm.controls.documentType.setValue(this.document.tipoDocumento.id.toString())
        this.tipoDocumentoSeleccionado = this.document.tipoDocumento
        const defaultType = this.documentTypes.find(type => type.descripcion === this.tipoDocumentoSeleccionado?.descripcion);
        if (defaultType) {
          this.tipoDocumentoSeleccionado = defaultType
          this.defaultDocumentType = defaultType.id.toString();
          this.replyForm.controls.documentType.setValue(this.defaultDocumentType);
        }
        this.cdr.detectChanges();
      }
    })
  }

  onDlgNumeracion() {
    const dialogRef = this.dlg.open(DlgNumeracionComponent, {});
    dialogRef.afterClosed().subscribe((result: any | undefined) => {
      if (result && result.id) {
        this.numeracionDocumento = result
        this.setNumeracion(result.numeracion);
        this.readOnlyNumeracion = true;
        this.numeracionInput!.nativeElement.blur();
        this.cdr.detectChanges();
      } else if (result === 1) {
        this.onEditConfirm();
      }
    });
  }

  loadNumeracionDocumento() {
    this.documentService.getNumeracion(this.tokenData.id).subscribe({
      next: (response) => {
        this.numeracionesDocumento = response || []
        if (this.numeracionesDocumento.length === 1) {
          this.numeracionDocumento = this.numeracionesDocumento[0];
          this.setNumeracion(this.numeracionesDocumento[0].numeracion);
          return;
        }
        if (this.numeracionesDocumento.length === 0) {
          this.replyForm.controls.numeracion.setValue("S/N")
          return;
        }
        if (this.numeracionesDocumento.length > 1) {
          this.replyForm.controls.numeracion.setValue("")
        }
      }
    })
  }

  setNumeracion(numeracion: string) {
    this.replyForm.controls.numeracion.setValue(numeracion);
    var numeracion = numeracion.replace("{ANIO}", new Date().getFullYear().toString());
    numeracion = numeracion.replace("{NUMERO}", "####");
    numeracion = numeracion.replace("{TIPO}", this.tipoDocumentoSeleccionado!.descripcion.substring(0, 2).toUpperCase());
    this.replyForm.controls.numeracion.setValue(numeracion);
  }

  openDlgAnexos() {
    const dlgDestino = this.dlg.open(DlgAnexosTareaComponent, {
      panelClass: "anexos-panel",
      data: this.document.idTarea
    });

    dlgDestino.afterClosed().subscribe((result: Anexo[] | undefined) => {
      if (result !== undefined) {
        result.forEach((anexo) => {
          const exists = this.anexos.some(existingAnexo => existingAnexo.id === anexo.id);
          if (!exists) {
            this.anexos.push(anexo);
          }
        });
      }
    });
  }

  getAnexosMencionados(): number[] {
    if (this.anexosFullComponent) {
      return this.anexosFullComponent.getAnexosMencionadosIds();
    }
    return [];
  }

  onDeleteAnexo(id: number) {
    const dlgDelete = this.dlg.open(DlgDeleteComponent, {
      width: '350px',
    });

    dlgDelete.afterClosed().subscribe(result => {
      if (result === 1) {
        this.tareaService.deleteAnexoTarea(id).subscribe({
          next: (_) => {
            this.anexos = this.anexos.filter((anexo) => anexo.id !== id);
            this.snackbarData.message = "Anexo eliminado!"
            this.snackbarData.style = SnackbarStyles.Success
            this.snackbarData.iconName = "check_circle"
            this.toast.show(this.snackbarData)
          }
        })
      }
    });
  }

  onEditConfirm() {
    const data: DlgConfirmComponentData = {
      title: "Editar numeraci\u00f3n?",
      message: "¿Est\xe1 seguro de continuar?",
      confirmLabel: "Si, continuar",
      closeLabel: "No"
    }
    const dialogRef = this.dlg.open(DlgConfirmComponent, {
      maxWidth: "40vw",
      width: "400px",
      data: data
    })
    dialogRef.afterClosed().subscribe((result: string | undefined) => {
      if (result) {
        this.readOnlyNumeracion = false;
        this.replyForm.controls.numeracion.setValue("");
        this.numeracionInput?.nativeElement.focus();
      }
    });
  }

  onCancel() {
    /* let currentAnexo = this.anexos.find((anexo) => anexo.tarea === this.document.idTarea)
    if (currentAnexo) {
      return this.onDeleteAnexo(currentAnexo.id!)
    }
    return this.location.back() */
  }

  onBack() {
    this.location.back();
  }

  openAnexo(anexoID: number) {
    const anexoType = this.anexos.find((anexo) => anexo.id === anexoID)?.estatus
    this.anexosService.getAnexoByID(anexoID, anexoType!).subscribe({
      next: (response) => {
        this.filesService.openFileFromOctectStream(response)
      }
    });
  }

  getAnexoOficio() {
    return this.anexos.find((anexo) => anexo.tipo === 0)!.id
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date!)
  }

  onCollaboraReady() {
    console.log('Editor Collabora listo');
  }

  onFullscreen(): void {
    this.fullscreenActive = true;
    this.collaboraEditor?.enterFullscreen();
  }

  onEditorFocus(focused: boolean): void {
    if (focused) this.editorHasFocus = true;
  }

  onCollaboraContentChanged() {
    // El documento se guarda automáticamente en Collabora

  }

  onCollaboraError(error: string) {
    this.toast.show({
      style: SnackbarStyles.Error,
      message: error
    });
  }

}
